const ru = {
  'appManuals.downloadHelpText':
    'Загруженные файлы можно просматривать через интернет-браузеры или программное обеспечение для чтения PDF.',
  'appManuals.systemRequirements':
    'Требования к оборудованию (рекомендуемые): процессор Intel® Core™ i3 или выше, 4 ГБ оперативной памяти или более, 100 МБ или более свободного места для сохранения PDF.',
  'appManuals.medicalsoftware.helptext':
    'Медицинская программа может отличаться в зависимости от страны.',
  '이미 등록된 라이선스가 있습니다.': 'Лицензия уже зарегистрирована.',
  '갱신 가능한 기존 라이선스를 찾을 수 없습니다.':
    'Не найдено существующей лицензии, доступной для продления.',
  '발급 가능한 잔여 수량이 없습니다.': 'Нет оставшегося количества для выдачи.',
  // --- eIFU portal UI labels & language names (issue #16) ---
  'show all manuals': 'Показать все руководства',
  'This site complies with the General Data Protection Regulation (EU 2016/679).': 'Этот сайт соответствует Общему регламенту по защите данных (EU 2016/679).',
  'This site meets the requirements of the General Data Protection Regulation (EU 2016/679).': 'Этот сайт отвечает требованиям Общего регламента по защите данных (EU 2016/679).',
  'the content of this site is protected against unauthorized modification.': 'Содержимое этого сайта защищено от несанкционированного изменения.',
  'Previous versions of the User Manual are available for viewing and downloading via search.': 'Предыдущие версии руководства пользователя доступны для просмотра и загрузки через поиск.',
  'Checking the latest documents.': 'Проверка последних документов.',
  'There are no manuals to display.': 'Нет руководств для отображения.',
  'Manuals': 'Руководства',
  'Product Name': 'Название продукта',
  'Language': 'Язык',
  'Document Name': 'Название документа',
  'Product': 'Продукт',
  'Revision': 'Редакция',
  'Document': 'Документ',
  'Published': 'Опубликовано',
  'English': 'Английский',
  'Korean': 'Корейский',
  'Japanese': 'Японский',
  'German': 'Немецкий',
  'Russian': 'Русский',
  'Chinese (Simplified)': 'Китайский (упрощённый)',
  'Chinese (Traditional)': 'Китайский (традиционный)',
  'Country': 'Страна',
  'eifuPortalIntro':
    'Поиск и загрузка электронных инструкций по применению (eIFU) для программного обеспечения медицинских изделий RAY.',
  "criticalNotice.badge": "Важное уведомление",
  "criticalNotice.close": "Закрыть",
};

export default ru;
